import { render, staticRenderFns } from "./CarouselNavButton.vue?vue&type=template&id=12dc35f9&scoped=true&"
import script from "./CarouselNavButton.vue?vue&type=script&lang=js&"
export * from "./CarouselNavButton.vue?vue&type=script&lang=js&"
import style0 from "./CarouselNavButton.vue?vue&type=style&index=0&id=12dc35f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dc35f9",
  null
  
)

export default component.exports